/** The last few spoken updates (text as spoken, newest first). */
import { useServerNow } from '../../lib/clock';
import { useCallouts } from '../../state/callouts';

const ago = (ms: number) => {
  const s = Math.max(0, Math.round(ms / 1000));
  return s < 60 ? `${s} s ago` : `${Math.round(s / 60)} min ago`;
};

export function RecentCallouts({ missionId, limit = 5, emptyText }: { missionId: string; limit?: number; emptyText?: string }) {
  const recent = useCallouts((s) => s.recent);
  const now = useServerNow(5000);
  const mine = recent.filter((c) => c.missionId === missionId).slice(0, limit);
  if (!mine.length) return emptyText ? <p className="callouts-empty muted small">{emptyText}</p> : null;
  return (
    <ol className="callouts-recent" data-testid="recent-callouts">
      {mine.map((c) => (
        <li key={c.id}>
          <span className="callouts-recent__text">{c.text}</span>
          <span className="callouts-recent__t num">{ago(now - c.t)}</span>
        </li>
      ))}
    </ol>
  );
}
